import React from 'react';
import { SizeContextProvider } from '../context/SizeProvider';
import { ComponentType } from '../types/components';
import { setTemplateItemId } from '../utils/templateItemId';
import { defaultProperties } from './defaultValues';
import { createParser } from './parser';
import { createRenderer } from './renderer';
export const createMessageTemplate = (opts) => {
    const Container = opts.Container || React.Fragment;
    const UnknownMessage = opts.UnknownMessage || (() => null);
    const parser = opts.parser || createParser();
    const renderer = opts.renderer || createRenderer();
    const MessageTemplateBase = (props) => {
        var _a;
        const renderItems = props.templateItems;
        const parentLayout = (_a = props.parentLayout) !== null && _a !== void 0 ? _a : defaultProperties.box.layout;
        return (React.createElement(React.Fragment, null, renderItems.map((item, index, siblings) => {
            const { properties } = parser.parse(item, { parentLayout, elemIdx: index, siblings });
            const props = {
                key: index,
                parentLayout,
                parsedProperties: properties,
                siblings,
            };
            switch (item.type) {
                case ComponentType.Box: {
                    return (React.createElement(renderer.box, Object.assign({}, item, props),
                        React.createElement(MessageTemplateBase, { templateItems: item.items || [], parentLayout: item.layout })));
                }
                case ComponentType.Text: {
                    return React.createElement(renderer.text, Object.assign({}, item, props));
                }
                case ComponentType.Image: {
                    return React.createElement(renderer.image, Object.assign({}, item, props));
                }
                case ComponentType.TextButton: {
                    return React.createElement(renderer.textButton, Object.assign({}, item, props));
                }
                case ComponentType.ImageButton: {
                    return React.createElement(renderer.imageButton, Object.assign({}, item, props));
                }
                default: {
                    // or throw new Error('Cannot parse template item')
                    return React.createElement(UnknownMessage, { item: item });
                }
            }
        })));
    };
    return {
        MessageTemplate: ({ parentLayout = defaultProperties.rootLayout, templateItems }) => {
            const items = setTemplateItemId(templateItems);
            return (React.createElement(SizeContextProvider, null,
                React.createElement(Container, null,
                    React.createElement(MessageTemplateBase, { parentLayout: parentLayout, templateItems: items }))));
        },
        MessageTemplateBase,
    };
};
